import { Typography } from '@mui/material'
import React, { PropsWithChildren, ReactElement, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import DataGrid from 'src/domains/query/components/DataGrid';
import EntityExplorer from 'src/domains/explorer/views/EntityExplorer';
import System from 'src/domains/system/components/System'
import Application from 'src/domains/extension/app/components/Application'
import { ENTITY, LIST, SYSTEM, BIZ_APPLICATION } from 'src/domains/types'
import { ComponentConf } from 'src/config'
import { changePage } from '../../actions'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import * as routes from '../../routes';

const CompContainer: React.FC<PropsWithChildren<{}>> = ({ children }) => {
    return <div className={'ui-component-container'}>{children}</div>
}

const getComponent: (conf: ComponentConf, search?: string) => ReactElement = (conf, search) => {
    if (conf.type === ENTITY) {
        // return <Entity {...conf} />
        // return <ResourceForm conf={conf} />
        return <EntityExplorer name={conf.resourceName} />

    } else if (conf.type === LIST) {
        // return <List listConf={conf} />
        return <DataGrid conf={conf} local={false}/>

    } else if (conf.type === SYSTEM) {
        return <System {...conf} />

    } else if (conf.type === BIZ_APPLICATION) {
        return <Application {...conf} />

    }
    return <div>
        <Typography>{`Unknown ui component type`}</Typography>
    </div>
}


const UIComponent: React.FC<{ componentConf: ComponentConf | ComponentConf[], search?: string }> = ({ componentConf, search }) => {
    const dispatch = useDispatch()

    useEffect(() => {
        // dispatch(changePageTitle('Admin UI Page'))
    }, [])

    const handleNavigate = (pathname: string) => (e: React.SyntheticEvent) => {
        dispatch(changePage(pathname));
    }

    const mainCompConf: ComponentConf = Array.isArray(componentConf) ? componentConf[0] : componentConf


    const renderComponent = (conf: ComponentConf, index: number, search?: string) => {
        return <CompContainer key={index}>{getComponent(conf)}</CompContainer>
    }

    const renderComponents: (conf: ComponentConf | ComponentConf[]) => ReactElement = (conf) => {
        if (Array.isArray(conf)) {
            return <div>{conf.map((cnf, index) => renderComponent(cnf, index, search))}</div>
        } else {
            return renderComponent(conf, 0, search)
        }
    }

    return (
        <div className={'root-router'}>

            <Breadcrumbs>
                <Link underline="hover" color="inherit" onClick={handleNavigate(routes.ROUTEADMIN)} sx={{ cursor: 'pointer' }}>Home</Link>
                <Link underline="none" color="text.primary">{mainCompConf.type}</Link>
            </Breadcrumbs>

            {renderComponents(componentConf)}
        </div>
    )
}

export default UIComponent
